<template>
  <v-layout column>
    <v-layout :column="$vuetify.breakpoint.xs">
      <v-flex>
        <v-layout column>
          <div>
            <checkbox v-model="form.privateReceipt" @input="form.r1Invoice = !form.r1Invoice ">
            {{ $t('privateReceipt') }}
            </checkbox>
          </div>
          <div>
            <checkbox v-model="form.r1Invoice" @input="form.privateReceipt = !form.privateReceipt ">
              {{ $t('r1Invoice') }}
            </checkbox>
          </div>
          <div v-if="form.r1Invoice">
            <text-field
              class="pb-16"
              v-model.trim="form.legalEntityName"
              :label="$t('legalEntityName')"
              type="text"
              :validator="vs.form.legalEntityName"
            />
            <text-field  
              class="pb-16"
              v-model="form.legalEntityOIB"
              label="OIB*"
              type="number"
              :validator="vs.form.legalEntityOIB"
            />
            <div class="pb-16 r1-row">
              <text-field
                v-model.trim="form.legalEntityAddress"
                :label="$t('addressLabel')"
                type="text"
                :validator="vs.form.legalEntityAddress"
              />
              <text-field
                v-model="form.legalEntityZipcode"
                :label="$t('zipCode')"
                type="number"
                :validator="vs.form.legalEntityZipcode"
              />
            </div>
            <div class="pb-16 r1-row">
              <text-field
                v-model.trim="form.legalEntityCity"
                :label="$t('city')"
                type="text"
                :validator="vs.form.legalEntityCity"
              />
              <v-combobox 
                outline
                class="select-r1-country"
                v-model="form.legalEntityCountry"
                :items="countries"
                item-text="common"
                item-value="common"
                :label="$t('country')"
                :validator="vs.form.legalEntityCountry"
                :return-object="false"
              />
            </div>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
const countries = require('../../assets/countries')
export default {
  name: 'receipt-form',
  props: {
    vs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        privateReceipt: true,
        r1Invoice: false,
        legalEntityCountry: 'Croatia'
      },
      countries
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style>
.r1-row {
  display: flex; 
  column-gap: 1.5rem; 
  flex-wrap: wrap;
}
.r1-row .v-input__append-inner {
  margin-left: -24px !important;
}
.r1-row .v-input__slot {
  height: 56px;
  border: 1px solid #d9d9d9 !important;
}
</style>
